import { render, staticRenderFns } from "./ObraDetalle.vue?vue&type=template&id=040387cc&scoped=true"
import script from "./ObraDetalle.vue?vue&type=script&lang=js"
export * from "./ObraDetalle.vue?vue&type=script&lang=js"
import style0 from "./ObraDetalle.vue?vue&type=style&index=0&id=040387cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040387cc",
  null
  
)

export default component.exports